import { PatchworkApiReturnCodes, type PatchworkRESTApiError } from "@patchwork/api/apireturncodes";
import { passwordForgot } from "@patchwork/api/user/userapi";

async function sendRequest() {
	let mailInput = document.getElementById("password-forgot") as HTMLInputElement;
	let errorHint = document.getElementById("user-unknown-hint") as HTMLParagraphElement;
	let formSection = document.getElementById("form") as HTMLElement;
	let successSection = document.getElementById("success") as HTMLElement;
	if (mailInput && errorHint) {
		if (!mailInput.checkValidity()) {
			mailInput.reportValidity();
			return;
		}

		var email = mailInput.value;
		var r = await passwordForgot(email);
		if (r.unpack()) {
			formSection.hidden = true;
			successSection.hidden = false;
			return;
		}

		var error = r.error() as PatchworkRESTApiError;
		if (error && error.errorCode === PatchworkApiReturnCodes.USERDOESNOTEXISTEXCEPTION) {
			errorHint.hidden = false;
			return;
		} else {
			errorHint.innerText = "Une erreur s'est produite. Réessayez utlérieument.";
			errorHint.hidden = false;
			return;
		}
	}
}

declare global {
	interface Window {
		passwordForgotPage : {
			sendRequest : () => void
		}
	}
}

window.passwordForgotPage = window.passwordForgotPage || { sendRequest : sendRequest }; 
